'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = require('../constants');

var _constants2 = require('@arreeba/ristoranti-lib/lib/constants');

var bootstrap = {
  api_endpoint: 'https://api.ristoranti.it/graphql',
  extra: {}
};

var initialState = {
  id: '',
  bootstrap: bootstrap,
  config: {},
  merchant: {},
  bookingRush: null,
  bookingRushSelectedRestaurant: '',
  bookingRushSelectedWindow: '',
  bookingRushNPosti: 2,
  bookingRushActiveRequest: null,
  connectivity: null,
  internetConnectionAvailable: false,
  userLocation: null,
  isFetching: false,
  passwordRecovery: {
    formValue: null,
    recoveryToken: null,
    processCompleted: false,
    emailSent: false
  }
};

exports.default = function () {
  var overrideBootstrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (state, action) {

    switch (action.type) {
      case _constants.LOAD_APP_CONFIGURATION_START:
        return _extends({}, state, {
          isFetching: true
        });

      case _constants.LOAD_APP_CONFIGURATION_SUCCESS:
        return _extends({}, state, {
          isFetching: false
        }, action.data, {
          config: JSON.parse(action.data.config)
        });

      case _constants.LOAD_APP_CONFIGURATION_FAILURE:
        return _extends({}, state, {
          isFetching: false,
          errors: action.errors
        });

      case _constants.SWITCH_BUNDLE_ID:
        return _extends({}, state, {
          bootstrap: _extends({}, state.bootstrap, {
            bundleId: action.newBundleId
          })
        });

      case _constants.SWITCH_API_ENDPOINT:
        return _extends({}, state, {
          bootstrap: _extends({}, state.bootstrap, {
            api_endpoint: action.endpoint
          })
        });

      case _constants.LOAD_MERCHANT_INFO_START:
        return _extends({}, state, {
          isFetching: true
        });

      case _constants.LOAD_MERCHANT_INFO_SUCCESS:
        return _extends({}, state, {
          isFetching: false,
          merchant: action.data[0].merchant
        });

      case _constants.LOAD_MERCHANT_INFO_FAILURE:
        return _extends({}, state, {
          isFetching: false,
          errors: action.errors
        });

      case _constants2.LOAD_BOOKING_AVAILABILITY_SUCCESS:
        return _extends({}, state, {
          bookingRush: action.data.bookingRushes[0]
        });

      case _constants.SELECT_BOOKING_RUSH_RESTAURANT:
        return _extends({}, state, {
          bookingRushSelectedRestaurant: action.restaurantId,
          bookingRushSelectedWindow: action.windowId
        });

      case _constants.SELECT_BOOKING_RUSH_RESTAURANT_WINDOW:
        return _extends({}, state, {
          bookingRushSelectedWindow: action.windowId,
          bookingRushNPosti: action.nPosti
        });

      case _constants.SET_ACTIVE_BOOKING_REQUEST:
        {
          var restaurant = action.activeBookingRequest.restaurant.id;
          var window = action.activeBookingRequest.availabilityWindow.id;

          return _extends({}, state, {
            bookingRush: _extends({}, state.bookingRush, {
              createdRequest: action.activeBookingRequest
            }),
            bookingRushSelectedRestaurant: restaurant,
            bookingRushSelectedWindow: window
          });
        }

      case _constants.UPDATE_CONNECTION_INFO:
        {
          var info = action.info;
          var disconnected = info in { none: 1, unknown: 1 };

          return _extends({}, state, {
            connectivity: action.info,
            internetConnectionAvailable: !disconnected
          });
        }

      case _constants.USER_LOCATION:
        return _extends({}, state, {
          userLocation: action.location
        });

      case _constants2.RESTAURANTS_REFRESH_SUCCESS:
        return _extends({}, state, {
          merchant: {
            restaurants: action.data
          }
        });

      // TODO move to @arreeba/ristoranti-lib
      case _constants.VERIFY_RECOVERY_TOKEN_START:
        return _extends({}, state, {
          isFetching: true
        });

      case _constants.VERIFY_RECOVERY_TOKEN_SUCCESS:
        return _extends({}, state, {
          isFetching: false,
          passwordRecovery: {
            formValue: null,
            recoveryToken: null
          }
        });

      case _constants.VERIFY_RECOVERY_TOKEN_FAILURE:
        return _extends({}, state, {
          isFetching: false,
          passwordRecovery: {
            formValue: null,
            recoveryToken: null,
            verified: false
          }
        });

      case _constants.UPDATE_RECOVERY_FORM_VALUE:
        return _extends({}, state, {
          passwordRecovery: _extends({}, state.passwordRecovery, {
            formValue: action.value
          })
        });

      case _constants.RESET_PASSWORD_START:
        return _extends({}, state, {
          isFetching: true,
          passwordRecovery: _extends({}, state.passwordRecovery)
        });

      case _constants.RESET_PASSWORD_SUCCESS:
        return _extends({}, state, {
          isFetching: false,
          passwordRecovery: _extends({}, state.passwordRecovery, {
            processCompleted: true
          })
        });

      case _constants.RESET_PASSWORD_FAILURE:
        return _extends({}, state, {
          isFetching: false,
          passwordRecovery: _extends({}, state.passwordRecovery, {
            processCompleted: false
          })
        });

      case _constants.RESET_RECOVERY_PASSWORD_STATUS:
        return _extends({}, state, {
          isFetching: false,
          passwordRecovery: _extends({}, initialState.passwordRecovery)
        });

      case _constants.RECOVERY_EMAIL_REQUEST:
        return _extends({}, state, {
          isFetching: false,
          passwordRecovery: _extends({}, state.passwordRecovery, {
            emailSent: true
          })
        });

      case _constants.SET_RECOVERY_TOKEN:
        return _extends({}, state, {
          passwordRecovery: _extends({}, state.passwordRecovery, {
            recoveryToken: action.token
          })
        });
    }

    if (!state) {
      return _extends({}, initialState, {
        bootstrap: _extends({}, bootstrap, overrideBootstrap)
      });
    }

    return state;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/reducers/app.js
// module id = 195
// module chunks = 0